<template>
  <div>
    <div class="card mb-2">
      <div class="card-header bg-primary text-white font-weight-bold">
        My Pending Instruments
      </div>
      <LoadingSpinner v-if="userStaffLeadInstrumentsLoading" message="" size='1x' />
      <p v-else-if="userStaffLeadInstruments.length === 0">
        You are not a Staff Lead of any Open Instruments
      </p>
      <div v-else>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">
                <span class='search-result-header'>Instrument ID</span>
              </th>
              <th scope="col">
                <span class='search-result-header'>Project Name</span>
              </th>
              <th scope="col">
                <span class='search-result-header'>Project ID</span>
              </th>
              <th scope="col">
                <span class='search-result-header'>Date Created</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="instrument in visibleInstruments">
              <tr
                v-bind:key="instrument.id"
                class="list-table-text">
                <td>
                  <router-link
                    :to="{ name: `projectInstrument`, params: {
                    project_id: instrument.primaryProject.id,
                    id: instrument.id }}"
                    class="view-link">
                    {{ formatIdString(instrument) }}
                  </router-link>
                </td>
                <td>
                  {{ instrument.primaryProject.name }}
                </td>
                <td :id="'instrument-proj' + instrument.id">
                  {{ instrument.primaryProject.id }}
                    <b-tooltip :target="'instrument-proj' + instrument.id">
                      {{instrument.projectName === null ? 'N/A' : instrument.projectName}}
                    </b-Tooltip>
                </td>
                <td>
                  {{ instrument.createdAt | dateString }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <PaginationControls
      :orderedEntities="userStaffLeadInstruments"
      :initialPageSize="initialPageSize"
      :pageSize="pageSize"
      :pageSizeOptions="pageSizeOptions"
      :currentPage="currentPage"
      :firstVisibleEntry="firstVisibleEntry"
      :lastVisibleEntry="lastVisibleEntry"
      :rows="rows"
      @update-current-page="updateCurrentPage"
      @update-page-size="updatePageSize">
    </PaginationControls>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { LookupModules } from '@/store/moduleConfig';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import Pagination from '@/mixins/Pagination';
import PaginationControls from '../common/PaginationControls.vue';

export default {
  name: 'MyInstruments',
  components: {
    LoadingSpinner,
    PaginationControls,
  },
  data() {
    return {
      pageSize: 100,
      currentPage: 1,
    };
  },
  props: {
    formatIdString: Function,
  },
  mixins: [Pagination],
  mounted() {
    // dispatch actions to populate vuex state for this page
    this.$store.dispatch(`${LookupModules.INSTRUMENT_TYPES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_TYPES.url);
  },
  computed: {
    ...mapState('Instrument', {
      userStaffLeadInstruments: state => state.userStaffLeadInstruments,
      userStaffLeadInstrumentsLoading: state => state.userStaffLeadInstrumentsLoading,
    }),
    ...mapGetters(LookupModules.INSTRUMENT_TYPES.namespace, {
      getInstrumentTypeProperty: 'getProperty',
    }),
    rows() {
      return this.userStaffLeadInstruments.length;
    },
    visibleInstruments() {
      // sort descending by openDate and ascending by serviceId
      return this.userStaffLeadInstruments
        .slice(0)
        .sort((a, b) => moment(a.openDate).format('YYYYMMDD')
          - moment(b.openDate).format('YYYYMMDD')
          || a.id - b.id)
        .slice(
          ((this.currentPage - 1) * this.pageSize),
          (this.currentPage * this.pageSize),
        );
    },
  },
};
</script>
